import React, { createContext, useCallback, useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link } from "react-router-dom";
import RecordatoriosTable from "../../components/RecordatoriosTable";
import useAuthFetch from "../../hooks/useAuthFetch";
import { DotLoader } from "react-spinners";
import { useSelector } from "react-redux";

export const recordatoriosContext = createContext();

const PAGE_SIZE = 10;

export default function RecordatoriosPage() {
  const authFetch = useAuthFetch();
  const [recordatorios, setRecordatorios] = useState();
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const [recordatorioSelected, setRecordatorioSelected] = useState();
  const [loadingEditar, setLoadingEditar] = useState(false);
  const { token } = useSelector((store) => store.app.user);

  const actualizarRecordatorios = useCallback(async () => {
    const buildWhereFilter = () => {
      if (!searchTerm || !searchTerm.trim()) return {};
      const term = searchTerm.trim();
      return {
        or: [
          { nombreCliente: { like: `%${term}%` } },
          { apellidoCliente: { like: `%${term}%` } },
          { nombreProducto: { like: `%${term}%` } },
          { telefono: { like: `%${term}%` } },
        ],
      };
    };

    setLoading(true);
    const where = buildWhereFilter();
    const filter = {
      where: Object.keys(where).length ? where : undefined,
      order: ["ultimaCompra DESC"],
      limit: PAGE_SIZE,
      skip: page * PAGE_SIZE,
    };
    const filterStr = encodeURIComponent(JSON.stringify(filter));
    const res = await authFetch(
      `listado-recordatorios?filter=${filterStr}`
    );

    if (!res?.ok) {
      setRecordatorios([]);
      setTotalPages(0);
      setLoading(false);
      return;
    }

    let data;
    try {
      data = await res.json();
    } catch {
      data = [];
    }
    const list = Array.isArray(data) ? data : [];
    setRecordatorios(list);

    const countUrl =
      Object.keys(where).length > 0
        ? `listado-recordatorios/count?where=${encodeURIComponent(JSON.stringify(where))}`
        : "listado-recordatorios/count";
    const totalReminderFetch = await authFetch(countUrl);
    let totalCount = 0;
    if (totalReminderFetch?.ok) {
      try {
        const totalReminder = await totalReminderFetch.json();
        totalCount = totalReminder.count ?? 0;
      } catch {
        /* ignore */
      }
    }
    setTotalPages(Math.ceil(totalCount / PAGE_SIZE));
    setLoading(false);
  }, [page, searchTerm, authFetch]);

  const editarRecordatorio = async (nuevoConsumo) => {
    setLoadingEditar(true);
    await authFetch(
      `recordatorios/venta/${recordatorioSelected.idVenta}/producto/${recordatorioSelected.idProducto}`,
      { nuevoConsumo },
      "PATCH",
      token
    );
    setLoadingEditar(false);
    actualizarRecordatorios();
  };

  const eliminarRecordatorio = async (recordatorio) => {
    const res = await authFetch(
      `recordatorios/venta/${recordatorio.idVenta}/producto/${recordatorio.idProducto}`,
      null,
      "DELETE"
    );
    if (res?.ok) {
      actualizarRecordatorios();
    }
    return res;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    actualizarRecordatorios();
  }, [page, actualizarRecordatorios]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setPage(0);
  };

  return (
    <recordatoriosContext.Provider
      value={{
        loading,
        actualizarRecordatorios,
        recordatorioSelected,
        setRecordatorioSelected,
        loadingEditar,
        editarRecordatorio,
        eliminarRecordatorio,
      }}
    >
      <div className="w-full p-content pb-16">
        <div className="flex flex-col gap-4">
          <Link to="/inventario">
            <button className="bg-pink text-white py-2 px-8 font-bold rounded-full float-right flex justify-center items-center">
              <IoMdArrowRoundBack className="text-lg" /> Volver
            </button>
          </Link>

          <h2 className="font-black text-2xl">Recordatorios</h2>
          <div className="flex gap-2 mb-4">
            <input
              type="text"
              placeholder="Buscar por cliente, teléfono o producto..."
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              className="rounded-full border-purple border p-3 flex-1 max-w-md"
            />
          </div>
          {loading && <DotLoader color="#76236C" />}
          {recordatorios && (
            <RecordatoriosTable
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              recordatorios={recordatorios}
            />
          )}
        </div>
      </div>
    </recordatoriosContext.Provider>
  );
}
